var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('loading-progress-bar'),_c('div',{staticClass:"container"},[_c('headerBlock'),_c('router-view'),(_vm.modalOpened)?_c('startGame'):_vm._e(),_c('footerBlock'),_c('notification_dispatcher')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }